import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { DraftPreface } from 'views/App/Portal/Policy/_types/manuals/draft';

export const getDraftPreface = async (manualId: string, prefaceId: string, staged?: boolean) => {
  let url = `${baseApiUrl()}/lexiverse/prefaces/v1/manuals/${manualId}/prefaces/${prefaceId}`;
  if (staged !== undefined) url += `?staged=${staged}`;
  const data = await fetcher({
    method: 'get',
    url,
  });
  return data;
};
export default function useDraftPreface(
  manualId?: string,
  prefaceId?: string,
  staged: boolean = true,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<DraftPreface, Error>(
    ['draft_preface', manualId, prefaceId, staged],
    async () => {
      const data = await getDraftPreface(manualId || '', prefaceId || '', staged || false);
      return data;
    },
    {
      ...options,
      enabled: !!prefaceId,
      keepPreviousData: false,
    }
  );
}
